import { useEffect, useRef } from 'react';

import { api, PostActivityLogPayload, Report } from '@/api';
import { useUser } from '@/core/user';

export const useCreateActivityLog = (report: Report) => {
  const { user } = useUser();

  const postActivityLogMutation = api.fct.activityLogs.mutation.usePostActivityLogs();
  const hasActivityLogCreated = useRef(false);

  const createActivityLog = () => {
    const postActivityLogPayload: PostActivityLogPayload = {
      action: 'READ',
      actor: user.user_id,
      fullObject: {
        userSession: true,
      },
      objectDiff: null,
      relatedObjectType: 'Report',
      relatedObjectUuid: report.uuid,
      reportUuid: report.uuid,
      studyId: report.studyId,
    };

    postActivityLogMutation.mutate({ payload: postActivityLogPayload });
  };

  useEffect(() => {
    if (hasActivityLogCreated.current) {
      return;
    }

    createActivityLog();
    hasActivityLogCreated.current = true;
  }, []);
};
